import { useForm } from '@/features/settings/components/NotificationConfiguration/form/index'
import { Form as FormValues } from '@/features/settings/components/NotificationConfiguration/form/types'
import { FC, ReactNode, useEffect } from 'react'
import { FormProvider } from 'react-hook-form'

interface FormProps {
    children: ReactNode
    initialFormValues: FormValues
}

const Form: FC<FormProps> = ({ children, initialFormValues }) => {
    const methods = useForm(initialFormValues)

    useEffect(() => {
        if (methods.formState.isDirty) return
        methods.reset(initialFormValues)
    }, [initialFormValues, methods])

    return <FormProvider {...methods}>{children}</FormProvider>
}

export default Form
